const SIDE_DRAWER_GAP = 16

// Since the drawer is fixed, measure the content area's height
// and pass it to _sidedrawer.scss as a custom property
let openSideDrawer = null

const sizeSideDrawer = () => {
    const drawer = openSideDrawer
    const content = document.getElementById('mainContentArea')
    if (!drawer || !content) return

    const area = content.getBoundingClientRect()
    const column = content.parentElement.getBoundingClientRect()

    // Sticky behaviour - match the content area
    const header = document.querySelector('nav.fixed-top')
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0
    const top = Math.max(area.top, headerBottom + SIDE_DRAWER_GAP)
    const bottom = Math.min(area.bottom, window.innerHeight - SIDE_DRAWER_GAP)

    const scroller = drawer.querySelector('.modal-content')
    const scrollbar = scroller ? scroller.offsetWidth - scroller.clientWidth : 0

    drawer.style.setProperty('--sidedrawer-scrollbar', scrollbar + 'px')
    drawer.style.setProperty('--sidedrawer-top', top + 'px')
    drawer.style.setProperty('--sidedrawer-right', (window.innerWidth - column.right) + 'px')
    drawer.style.setProperty('--sidedrawer-height', Math.max(0, bottom - top) + 'px')
}

const trackSideDrawer = (drawer) => {
    openSideDrawer = drawer
    sizeSideDrawer()
    window.addEventListener('resize', sizeSideDrawer)
    window.addEventListener('scroll', sizeSideDrawer, {passive: true})
}

let drawerTrail = []
const drawerKeyOf = (modal) => modal.id.replace(/Modal$/, '')

let modalOpener = null

const returnFocusToOpener = (opener) => {
    if (opener && document.contains(opener) && !opener.closest('.modal-backdrop-hidden')) {
        opener.focus()
        return
    }
    const firstTab = document.getElementById('firstTabIndex')
    if (firstTab) firstTab.focus()
}

const releaseSideDrawer = () => {
    window.removeEventListener('resize', sizeSideDrawer)
    window.removeEventListener('scroll', sizeSideDrawer)
    document.body.classList.remove('side-drawer-open')
    if (!openSideDrawer) return

    openSideDrawer.classList.add('modal-backdrop-hidden')
    if (openSideDrawer.children[0]) {
        openSideDrawer.children[0].classList.add('modal-hidden')
    }
    openSideDrawer.style.removeProperty('--sidedrawer-scrollbar')
    openSideDrawer.style.removeProperty('--sidedrawer-top')
    openSideDrawer.style.removeProperty('--sidedrawer-right')
    openSideDrawer.style.removeProperty('--sidedrawer-height')
    openSideDrawer = null
}

export const resetSideDrawer = () => {
    drawerTrail = []
    modalOpener = null
    releaseSideDrawer()
}

const getModal = () => {


    const renderDrawerBack = (drawer) => {
        const header = drawer.querySelector('.modal-header')
        if (!header) return false
        const existing = header.querySelector('[data-drawer-back]')
        if (existing) existing.remove()
        // getHelpWindow.js draws its own Back for answers nested in a FAQ body
        if (!drawerTrail.length || header.querySelector('.previous-link')) return true

        const link = document.createElement('div')
        link.className = 'previous-link'
        link.setAttribute('data-drawer-back', '')
        const button = document.createElement('button')
        button.type = 'button'
        const arrow = document.createElement('span')
        arrow.className = 'd-inline-block back-arrow'
        const label = document.createElement('span')
        label.className = 'back-label'
        label.textContent = 'Back'
        button.appendChild(arrow)
        button.appendChild(label)
        button.addEventListener('click', goBackToPreviousDrawer)
        link.appendChild(button)
        header.appendChild(link)
        return true
    }

    const renderDrawerBackWhenReady = (drawer) => {
        if (renderDrawerBack(drawer)) return
        let attempts = 0
        const retry = setInterval(() => {
            if (renderDrawerBack(drawer) || ++attempts >= 5 || openSideDrawer !== drawer) {
                clearInterval(retry)
            }
        }, 500)
    }

    const goBackToPreviousDrawer = () => {
        const previousKey = drawerTrail.pop()
        if (previousKey) showModal(previousKey, true)
    }

    const showModal = (name, isBack) => {
        name += 'Modal'
        const modal = document.getElementById(name)
        let id = name + 'CloseBtn'
        if (modal) {
            // Close old faq and replace with new faq
            const previous = openSideDrawer && openSideDrawer !== modal ? openSideDrawer : null

            if (!isBack && !previous) {
                const active = document.activeElement
                modalOpener = active && active !== document.body ? active : null
            }
            if (previous) {
                previous.classList.add('side-drawer-swap')
                modal.classList.add('side-drawer-swap')
                previous.classList.add('modal-backdrop-hidden')
                previous.children[0].classList.add('modal-hidden')
                releaseSideDrawer()
            }

            modal.classList.remove('modal-backdrop-hidden')
            modal.children[0].classList.remove('modal-hidden')
            if (modal.classList.contains('side-drawer')) {
                if (!isBack && previous) {
                    drawerTrail.push(drawerKeyOf(previous))
                }
                document.body.classList.add('side-drawer-open')
                trackSideDrawer(modal)
                if (!modal.dataset.drawerBackBound) {
                    modal.dataset.drawerBackBound = 'true'
                    modal.addEventListener('faqContentReplaced', () => renderDrawerBack(modal))
                }
                renderDrawerBackWhenReady(modal)
            }

            if (previous) {
                // flush the swap so the transition is only suppressed for this frame
                void modal.offsetWidth
                previous.classList.remove('side-drawer-swap')
                modal.classList.remove('side-drawer-swap')
            }
            // notify the modal component it's now visible (FAQModal reads its data on this)
            modal.dispatchEvent(new CustomEvent('modalShown'))
            // the FAQ body renders a tick later, so the scrollbar is not there yet
            requestAnimationFrame(() => requestAnimationFrame(sizeSideDrawer))
        }
        const closeButton = document.getElementById(id)
        if (closeButton) {
            closeButton.focus()
        } else if (modal) {
            // A dialog with no close X opts in with tabindex="-1" so nothing looks pre-selected (#437)
            const dialog = modal.querySelector('[role="dialog"][tabindex="-1"]')
            if (dialog) {
                dialog.focus()
            }
        }
		if (name.includes('faq')) {
			sessionStorage.setItem('currentFaqModalId', name.replace('faq', '').replace('Modal', ''))
		}
    }

    const closeModal = (name) => {
        name += 'Modal'
	    const modal = document.getElementById(name)
	    const opener = modalOpener
	    modal.classList.add('modal-backdrop-hidden')
	    modal.children[0].classList.add('modal-hidden')
        if (modal.classList.contains('side-drawer') && openSideDrawer === modal) {
		    resetSideDrawer()
	    }

	    if (openSideDrawer) return

	    modalOpener = null
        returnFocusToOpener(opener)
    }

    const showDifferentModal = (currentModal, newModal) => {
        const next = document.getElementById(newModal + 'Modal')
        const opener = modalOpener
        closeModal(currentModal)
        if (next && next.classList.contains('side-drawer')) {
            drawerTrail.push(currentModal)
        }
        showModal(newModal, true)
        modalOpener = opener
    }

    return {
        showModal,
        closeModal,
        showDifferentModal,
    }
}

export default getModal